export const messages = Object.freeze({
    access_denied: "You don't have access to this resource.",
    insufficient_resource_pool_or_tenant_role: "You don't have permission to perform this action.",
    insufficient_resource_pool_role: "You don't have permission to perform this action.",
    insufficient_space_role: "You don't have permission to perform this action.",
    insufficient_tenant_role: "You don't have permission to perform this action.",
    invalid_auth_category: 'Invalid auth category. Please check your input and try again.',
    invalid_auth_param: 'Invalid auth param. Please check your input and try again.',
    invalid_role_type: 'Invalid role type. Please check your input and try again.',
    not_space_admin: 'Only space administrators can perform this action.',
    unauthorized: "You don't have permission to perform this action.",
    unrecognised_role_method: 'Unrecognised role method. Please check your input.',
    user_is_not_m2m: 'This action is only available to machine-to-machine users.',
    user_is_not_sysadmin: 'Only system administrators can perform this action.'
})

export const dialogs = Object.freeze({
    insufficient_org_role: {
        dialogTitle: 'Permission denied',
        dialogText: 'You do not have permission for this action, please check if you have the right URL.',
        dialogAction: ['returnToWelcomePage'],
        primaryAction: ['returnToWelcomePage']
    },
    insufficient_instance_role: {
        dialogTitle: 'Permission denied',
        dialogText: 'You do not have permission for this action, please check if you have the right URL.',
        dialogAction: ['returnToWelcomePage'],
        primaryAction: ['returnToWelcomePage']
    }
})
